import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { PageCategoryStore } from './page-category.store';

@Injectable({
    providedIn: 'root'
})
export class PageCategoryQuery extends BaseQuery {

    constructor(store: PageCategoryStore) {
        super(store);
    }


}
